import { FC } from 'react'
import { QueryParams } from '../../../../../../types/strapi/strapi'
import { useWatch } from 'antd/es/form/Form'
import { NamePath } from 'antd/es/form/interface'
import MaterialInCuttingIndicator from '../../../../../../components/material-in-cutting-indicator/material-in-cutting-indicator'
import { Flex, Space } from 'antd'
import Title from 'antd/es/typography/Title'
import { MaterialRequirements } from '../../types/form-values'
import { roundUpToTwoDecimals } from '../../../../../../helpers/round-up-to-two-decimals'

export const query: QueryParams = {
    fields: ['documentId', 'name'],
    pagination: { pageSize: 200, page: 1 },
}

interface HeaderProps {
    namePath: NamePath
    prefix?: NamePath
    necessary?: number
}

const Header: FC<HeaderProps> = ({ namePath, prefix = [], necessary }) => {
    const fullName = [...prefix, ...namePath]
    const materialTypeNamePath = [...fullName, 'materialTypeName']
    const materialInCuttingPath = [...fullName, 'materialInCutting']
    const configurationsPath = [...fullName, 'configurations']

    const materialTypeName = useWatch(materialTypeNamePath)
    const materialInCutting = useWatch(materialInCuttingPath)
    const configurations =
        (useWatch(configurationsPath) as MaterialRequirements['configurations']) || []
    const selected = configurations.reduce((sum, cur) => sum + (cur.amount || 0), 0)

    return (
        <Flex justify={'space-between'}>
            <Space size={4} align='center'>
                <Title style={{ margin: 0 }} level={5}>
                    {materialTypeName}
                </Title>
                {materialInCutting ? <MaterialInCuttingIndicator /> : null}
            </Space>
            <Space>
                <span>
                    Выбрано: <b>{selected} км</b> из{' '}
                    <b>{roundUpToTwoDecimals(necessary || 0)} км</b>
                </span>
                <span>
                    Необходимо:{' '}
                    <b>
                        {roundUpToTwoDecimals((necessary === undefined ? 0 : necessary) - selected)}{' '}
                        км
                    </b>
                </span>
            </Space>
        </Flex>
    )
}

export default Header
